// Constants
import { Endpoints } from "~constants/endpoints"

// Constants
const QUERY_PARAM_REGEX = /((\?|\&)([^=]+)\=([^&]+))*/
const QUERY_SRC = QUERY_PARAM_REGEX.source
const BY_ID_REGEX = new RegExp(`[a-zA-Z-0-9]+${QUERY_SRC}$`)
const BY_ID_SRC = BY_ID_REGEX.source
const PROJECTION_REGEX = /projection\=[a-zA-Z]+\&*/

// USER Regex Constants
const GET_USER_REGEX = new RegExp(`^(${Endpoints.USERS.URL})/[a-zA-Z-0-9]+$`)
const GET_PERK_REGEX = new RegExp(`^(${Endpoints.PERKS.URL})/${BY_ID_SRC}$`)
const GET_POST_REGEX = new RegExp(`^(${Endpoints.MESSAGES.URL})/${BY_ID_SRC}$`)
const GET_USERS_REGEX = new RegExp(`^(${Endpoints.USERS.URL})${QUERY_SRC}$`)
const GET_PERKS_REGEX = new RegExp(`^(${Endpoints.PERKS.URL})${QUERY_SRC}$`)
const GET_POSTS_REGEX = new RegExp(`^(${Endpoints.MESSAGES.URL})${QUERY_SRC}$`)

const removeProjection = (url: string): string => {
  return url.replace(PROJECTION_REGEX, "")
}

export const urlMapper = (url: string, cid: string): string => {
  // USERS
  if (GET_USERS_REGEX.test(url) || GET_USER_REGEX.test(url)) {
    return url.replace(
      Endpoints.USERS.URL,
      `${Endpoints.COMPANIES.URL}/${cid}/users`
    )
  }
  // PERKS
  if (GET_PERKS_REGEX.test(url) || GET_PERK_REGEX.test(url)) {
    url = removeProjection(url)
    return url.replace(
      Endpoints.PERKS.URL,
      `${Endpoints.COMPANIES.URL}/${cid}/perks`
    )
  }
  // POSTS
  if (GET_POSTS_REGEX.test(url) || GET_POST_REGEX.test(url)) {
    url = removeProjection(url)
    return url.replace(
      Endpoints.MESSAGES.URL,
      `${Endpoints.COMPANIES.URL}/${cid}/posts`
    )
  }

  // Default
  return url
}
